<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('friends-updates')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add friends updates</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <b-form-group label="Title">
          <base-input
            alternative
            class="mb-3"
            name="Title"
            :rules="{ required: true }"
            placeholder="Title"
            v-model="title"
            required
          >
          </base-input>
        </b-form-group>
        <b-form-group
          label="Friends updates image (Max size 5MB and Dimensions should H-700, W-900)"
        >
          <FileUploader
            v-show="!coverImage"
            :image="image"
            :onSuccess="handleSuccess"
          />
          <Cropper
            class="cropper"
            :src="image"
            v-if="coverImage != ''"
            @change="handleCropperChange"
            ref="cropper"
            :stencil-props="{
              aspectRatio: 2 / 1,
            }"
          />

          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <span v-if="imageErr" class="flex justify-center small text-danger">{{
            msg.image
          }}</span>
          <img v-if="image" :src="cropperImg" ref="cover" />
        </b-form-group>
        <b-form-group label="Description">
          <quill-editor
            v-model="description"
            :options="editorOption"
            class="quill-h200px my-2"
            @input="validateDescription"
          />
          <!-- <small class="text-muted">
            {{ description.length }} / 1500 characters used
          </small>
          <div v-if="descriptionError" class="text-danger">
            {{ descriptionError }}
          </div> -->
        </b-form-group>

        <div class="mb-2 w-1/3">
          <div>
            <label for="date">Date:</label>
          </div>
          <el-date-picker
            v-model="date"
            type="date"
            placeholder="Pick a date"
            :default-value="new Date()"
            format="dd-MM-yyyy"
            name="date"
          >
          </el-date-picker
          ><br />
          <span v-if="dateErr" class="text-center small text-danger">{{
            msg.date
          }}</span>
        </div>

        <!-- <div class="mb-2 pad">
          <b-form-radio-group
            v-model="isActive"
            :options="isActiveOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
          ></b-form-radio-group>
        </div> -->

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
import _ from "lodash";
import { DatePicker } from "element-ui";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      // isActiveOptions: [
      //   { item: true, name: "Active" },
      //   { item: false, name: "In-Active" },
      // ],
      // isActive: true,
      title: "",
      image: "",
      coverImage: "",
      cropperImg: "",
      msg: {
        name: "",
        image: "",
        date: "",
      },
      editorOption: {
        theme: "snow",
      },
      description: "",
      date: null,
      imageErr: false,
      dateErr: false,
      // descriptionError: "",
    };
  },
  computed: {
    ...mapState("friendsUpdates", {
      friendsUpdates: "friendsUpdates",
    }),
  },

  methods: {
    // validateDescription() {
    //   const maxChars = 1500;
    //   if (this.description.length > maxChars) {
    //     this.description = this.description.slice(0, maxChars);
    //     this.descriptionError = `Description cannot exceed ${maxChars} characters.`;
    //   } else {
    //     this.descriptionError = "";
    //   }
    // },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    handleCropperChange(img) {
      // console.log(img);
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },
    handleSuccess(image) {
      // console.log(image);

      // 1048576
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      // console.log(this.date);
      if (this.date === null) {
        this.dateErr = true;
        this.msg.date = "Date is required";
        return;
      }
      // let FormData = require("form-data");
      let data = new FormData();

      data.append("title", this.title);
      data.append("date", this.date);
      if (this.description) data.append("description", this.description);
      if (!this.description) {
        // this.$swal.fire({
        //   text: "Description is required  ",
        //   confirmButtonText: "Okay",
        //   confirmButtonColor: "#830c81",
        //   showCancelButton: false,
        // });
        this.$notify.error({
          message: "Description is required  ",
          position: "top-right",
        });

        return;
      }

      if (this.coverImage) data.append("image", this.coverImage);
      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const Frddata = await this.$store.dispatch(
          "friendsUpdates/createFriends",
          data
        );
        if (Frddata.code == 200) {
          // this.$router.push({ name: "partnership" });
          this.$router.push({ name: "friends-updates" });
          this.$swal.fire({
            text: "Data successfully added",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }

        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {},
  //   async mounted() {
  //   this.$store.dispatch("campaignPageBanner/get_campaignhome");
  //   console.log("eeeee", this.campaignHome);
  // },
};
</script>
<style>
/* .pad .custom-control {
  padding-left: 1rem !important;
} */
</style>
